module.exports = __webpack_public_path__ + "static/img/product_list0.8641bfa3.png";